"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var createIcon_1 = __importDefault(require("../createIcon"));
var BrandIconHomeAndAuto = function (props) {
    return (react_1.default.createElement(createIcon_1.default, __assign({ role: "img", ariaLabel: "HomeAndAuto" }, props),
        react_1.default.createElement("title", null, "Home and Auto"),
        react_1.default.createElement("path", { d: "M77.99 102.857h33.438V31.436L65.721 8.57 20.025 31.425v68.54", fill: "#007562" }),
        react_1.default.createElement("path", { d: "M25.714 102.857a8.569 8.569 0 01-8.571 8.571 8.568 8.568 0 01-8.572-8.571v-4.403h17.122l.021 4.403zM85.714 102.857a8.569 8.569 0 01-8.571 8.571 8.569 8.569 0 01-8.572-8.571v-4.403h17.122l.021 4.403z", fill: "#000" }),
        react_1.default.createElement("path", { d: "M85.714 74.282H8.571v28.575h77.143V74.282z", fill: "#D44513" }),
        react_1.default.createElement("path", { d: "M22.468 94.071a5.893 5.893 0 100-11.785 5.893 5.893 0 000 11.785zM68.571 94.071a5.893 5.893 0 100-11.785 5.893 5.893 0 000 11.785z", fill: "#000" }),
        react_1.default.createElement("path", { d: "M8.571 74.282L20.432 51.43h53.314l11.968 22.853H8.571z", fill: "#FF6E00" })));
};
exports.default = BrandIconHomeAndAuto;
